'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.QueryValidationError = exports.QueryValidationErrors = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _operators = require('./operators');

var operators = _interopRequireWildcard(_operators);

var _ValueSetRegistry = require('./ValueSetRegistry');

var _ValueSetRegistry2 = _interopRequireDefault(_ValueSetRegistry);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function formatErrorMessage(error) {
    var message = error.type + ': ' + error.message;
    if (error.property) {
        message = message + ' (see ' + error.property + ' property)';
    }
    return message;
}

var QueryValidationErrors = exports.QueryValidationErrors = function () {
    function QueryValidationErrors() {
        (0, _classCallCheck3.default)(this, QueryValidationErrors);

        this._errors = [];
    }

    (0, _createClass3.default)(QueryValidationErrors, [{
        key: 'hasErrors',
        value: function hasErrors() {
            return this._errors.length > 0;
        }
    }, {
        key: 'add',
        value: function add(type, id, message, property) {
            this._errors.push(new QueryValidationError(type, id, message, property));
        }
    }, {
        key: 'combine',
        value: function combine(queryValidationErrors) {
            var _newErrors$errors, _newErrors$errors2;

            var newErrors = new QueryValidationErrors();
            (_newErrors$errors = newErrors.errors).splice.apply(_newErrors$errors, [0, 0].concat((0, _toConsumableArray3.default)(this.errors)));
            (_newErrors$errors2 = newErrors.errors).splice.apply(_newErrors$errors2, [this.errors.length, 0].concat((0, _toConsumableArray3.default)(queryValidationErrors.errors)));
            return newErrors;
        }
    }, {
        key: 'isValidOperator',
        value: function isValidOperator(operator, dataType, cardinality) {
            var operatorClass = operators.getOperatorSet(dataType, cardinality) || 'all';
            var allowedOperators = operators[operatorClass];
            return (0, _keys2.default)(allowedOperators).indexOf(operator) !== -1;
        }
    }, {
        key: 'getValueSetCardinality',
        value: function getValueSetCardinality(valueSet) {
            if (!valueSet) {
                return null;
            }
            var valueSetType = _ValueSetRegistry2.default.resolve(valueSet._type);
            return valueSetType && valueSetType.cardinality ? valueSetType.cardinality : null;
        }
    }, {
        key: 'isValueMissing',
        value: function isValueMissing(value) {
            return _lodash2.default.isNil(value) || value === '';
        }
    }, {
        key: 'errors',
        get: function get() {
            return this._errors;
        }
    }, {
        key: 'message',
        get: function get() {
            return this._errors.map(formatErrorMessage).join('; ');
        }
    }]);
    return QueryValidationErrors;
}();

var QueryValidationError = exports.QueryValidationError = function () {
    function QueryValidationError(type, id, message, property) {
        (0, _classCallCheck3.default)(this, QueryValidationError);

        this.type = type;
        this.id = id;
        this.message = message;
        this.property = property;
    }

    (0, _createClass3.default)(QueryValidationError, [{
        key: 'getError',
        value: function getError() {
            var type = this.type,
                id = this.id,
                message = this.message,
                property = this.property;

            return { type: type, id: id, message: message, property: property };
        }
    }]);
    return QueryValidationError;
}();

exports.default = QueryValidationErrors;